module.exports = __webpack_public_path__ + "img/plashka.4c8a971b.jpg";